﻿import Vue from "vue";
import Component from "vue-class-component";
import common = require("../../common");
import context = require("../context");
import HotEditableFormLoader = require("./hotEditable/HotEditableFormLoader");

@Component
class MainFooterVue extends Vue {
    culture: string;
    _initCulture = null as string;
    _onCultureChangeCallback = null as (culture: common.Cultures) => void;

    beforeCreate() {
        const rootId = (this as any).$initialData.vueElId as string;
        this._initCulture = (this as any).$initialData.currentCulture as common.Cultures;
        HotEditableFormLoader.prepareComponentsMarkupFromTarget(false, false, rootId);//.loadComponentsFromParent(this);
        //const formName = (this as any).$initialData.formName;
        // this.formManager = new HotEditableFormManager(this, formName, {
        //     loadFormModeFromUrl: (this as any).$initialData.loadFormModeFromUrl !== false,
        //     embeddedContentModels: (((this as any).$initialData.embeddedContentModels || []) as common.IEmbeddedContentModel[]).sort((a, b) => {
        //         return a.order - b.order;
        //     })
        // });
        // this.shared = new SharedHotEditableParentForm(this.formManager);
        this.$options.el = '#' + rootId;
    }
    data() {
        const c = this._initCulture ? common.Cultures[this._initCulture] ?? (() => { throw "La culture '" + this._initCulture + "' n'est pas supportée."; })() : common.Cultures.fr;
        const o = {
            culture: c
        };
        return o;
    }
    // destroyComponents() {
    //     this.formManager.destroyComponents();
    //     this.formManager = null;
    //     return this;
    // }

    created() {
    }

    mounted() {
    }
    setCutlure(culture: common.Cultures) {
        if (!culture)
            throw "L'argument 'callback' est NULL.";
        if (!common.Cultures[culture])
            throw "La culture '" + culture + "' n'existe pas.";
        this.culture = culture;
        return this;
    }
    /** Sequence: thisVue.updateCulture > update the culture context name > callbak(post API & wait updatedCulture) > thisVue.setCulture */
    refreshCultureFromContext() {
        this.setCutlure(context.culture.get());
        return this;
    }
}

export = MainFooterVue;